import { jsx as _jsx } from "react/jsx-runtime";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy, } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
const SortableItem = ({ id, children, disabled }) => {
    const { attributes, listeners, setNodeRef, transform, transition, } = useSortable({ id, disabled });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    return (_jsx("div", Object.assign({ ref: setNodeRef, style: style }, attributes, listeners, { children: children })));
};
export const SortableList = (props) => {
    const { items, renderItem, onSort, disableSort = false } = props;
    const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates,
    }));
    function handleDragEnd(event) {
        const { active, over } = event;
        if (!over || active.id === over.id)
            return;
        const oldIndex = items.findIndex((_, idx) => `row${idx}` === active.id);
        const newIndex = items.findIndex((_, idx) => `row${idx}` === over.id);
        const newItems = arrayMove(items, oldIndex, newIndex);
        onSort(newItems);
    }
    return (_jsx(DndContext, { sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd, children: _jsx(SortableContext, { items: items.map((_, i) => `row${i}`), strategy: verticalListSortingStrategy, children: _jsx("div", { className: "uxpcore_sortablelist main-container", children: items === null || items === void 0 ? void 0 : items.map((s, i) => (_jsx(SortableItem, { id: `row${i}`, disabled: disableSort, children: renderItem(s, i) }, `row${i}`))) }) }) }));
};
